import { CompanyPreferences, PermissionType, logger } from '$utils'
import useAppStore, { isAppStateReady } from 'src/state/store'
import { defer } from 'react-router-dom'
import usePayrollStore from '../store'
import { AccountingSystem, AuthModule, PayrollSystem } from '$constants'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Pay Runs loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Pay Runs loader')

  const { activeCompany } = useAppStore.getState()
  const hasManagerPermission =
    activeCompany?.hasPermission(PermissionType.Manager) ?? false

  const payrollSystemPreference: string | null = activeCompany?.preference(
    CompanyPreferences.PayrollSystem
  )

  const xeroConnection = !payrollSystemPreference
    ? null
    : usePayrollStore
        .getState()
        .checkExternalSystemConnection(AuthModule.Time, AccountingSystem.Xero)
        .then((result) => {
          if (!result?.hasAuth || !hasManagerPermission) return

          const promises: Promise<void>[] = [
            usePayrollStore
              .getState()
              .getPayRuns(payrollSystemPreference as unknown as PayrollSystem),
            usePayrollStore
              .getState()
              .getCalendars(
                payrollSystemPreference as unknown as PayrollSystem
              ),
          ]

          return Promise.all(promises)
        })

  return defer({
    data: Promise.all([xeroConnection])
      .then(() => true)
      .catch((error) => {
        logger.error('Payruns Promise.all error', error)
        return false
      }),
  })
}
